import Styled from 'styled-components'
import { maxQuery } from '../../../../helpers'

export default Styled.div`
    .welcome-section {
        margin-bottom: 2em;
        
        h1 {
            font-size: 2rem;
            font-weight: 700;
            color: #fff;
            margin: 0 0 0.5em 0;
            
            ${maxQuery('md')} {
                font-size: 1.5rem;
            }
        }
        
        p {
            font-size: 1rem;
            color: rgba(255, 255, 255, 0.7);
            margin: 0;
        }
    }
    
    .stats-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
        gap: 1.5em;
        margin-bottom: 2em;
        
        .stat-card {
            background: #272B4A;
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-left: 4px solid;
            border-radius: 8px;
            padding: 1.5em;
            display: flex;
            gap: 1.5em;
            align-items: center;
            transition: all 0.2s;
            
            &:hover {
                transform: translateY(-4px);
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
            }
            
            .stat-icon {
                width: 60px;
                height: 60px;
                border-radius: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 1.5rem;
                flex-shrink: 0;
            }
            
            .stat-content {
                flex: 1;
                
                .stat-label {
                    font-size: 0.85rem;
                    color: rgba(255, 255, 255, 0.6);
                    margin: 0 0 0.5em 0;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }
                
                .stat-value {
                    font-size: 2rem;
                    font-weight: 700;
                    color: #fff;
                    margin: 0 0 0.3em 0;
                    
                    ${maxQuery('md')} {
                        font-size: 1.5rem;
                    }
                }
                
                .stat-change {
                    font-size: 0.8rem;
                    color: rgba(255, 255, 255, 0.5);
                    margin: 0;
                }
            }
        }
    }
    
    .content-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        gap: 1.5em;
        margin-bottom: 2em;
        
        .card {
            background: #272B4A;
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-radius: 8px;
            padding: 1.5em;
            
            .card-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 1.5em;
                padding-bottom: 1em;
                border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                
                h3 {
                    font-size: 1.2rem;
                    font-weight: 600;
                    color: #fff;
                    margin: 0;
                }
                
                .view-all-btn {
                    background: transparent;
                    border: 1px solid ${({ theme }) => theme.primary};
                    color: ${({ theme }) => theme.primary};
                    padding: 0.5em 1em;
                    border-radius: 6px;
                    font-size: 0.85rem;
                    cursor: pointer;
                    transition: all 0.2s;
                    
                    &:hover {
                        background: ${({ theme }) => theme.primary};
                        color: #fff;
                    }
                }
            }
            
            h3 {
                font-size: 1.2rem;
                font-weight: 600;
                color: #fff;
                margin: 0 0 1.5em 0;
                padding-bottom: 1em;
                border-bottom: 1px solid rgba(255, 255, 255, 0.1);
            }
            
            .orders-list, .companies-list {
                display: flex;
                flex-direction: column;
                gap: 1em;
                max-height: 400px;
                overflow-y: auto;
                
                &::-webkit-scrollbar {
                    width: 6px;
                }
                
                &::-webkit-scrollbar-track {
                    background: rgba(255, 255, 255, 0.05);
                    border-radius: 3px;
                }
                
                &::-webkit-scrollbar-thumb {
                    background: rgba(255, 255, 255, 0.2);
                    border-radius: 3px;
                    
                    &:hover {
                        background: rgba(255, 255, 255, 0.3);
                    }
                }
                
                .order-item, .company-item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 1em;
                    background: rgba(255, 255, 255, 0.03);
                    border: 1px solid rgba(255, 255, 255, 0.08);
                    border-radius: 6px;
                    cursor: pointer;
                    transition: all 0.2s;
                    
                    &:hover {
                        background: rgba(255, 255, 255, 0.06);
                        border-color: rgba(255, 255, 255, 0.15);
                        transform: translateX(3px);
                    }
                    
                    .order-info, .company-info {
                        flex: 1;
                        display: flex;
                        align-items: center;
                        gap: 0.8em;
                        
                        .company-icon {
                            font-size: 1.5rem;
                            color: ${({ theme }) => theme.primary};
                            opacity: 0.8;
                        }
                        
                        .order-tracking, .company-name {
                            font-size: 0.9rem;
                            font-weight: 600;
                            color: ${({ theme }) => theme.primary};
                            margin: 0 0 0.3em 0;
                        }
                        
                        .order-customer, .company-email {
                            font-size: 0.85rem;
                            color: rgba(255, 255, 255, 0.6);
                            margin: 0;
                        }
                    }
                    
                    .order-status, .company-status {
                        display: flex;
                        flex-direction: column;
                        align-items: flex-end;
                        gap: 0.3em;
                        
                        .status-badge {
                            padding: 0.3em 0.8em;
                            border-radius: 12px;
                            font-size: 0.75rem;
                            font-weight: 600;
                            color: #fff;
                            text-transform: uppercase;
                            letter-spacing: 0.5px;
                        }
                        
                        .order-time, .company-time {
                            font-size: 0.75rem;
                            color: rgba(255, 255, 255, 0.4);
                        }
                    }
                }
                
                .empty-state {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 3em 1em;
                    color: rgba(255, 255, 255, 0.5);
                    
                    svg {
                        margin-bottom: 1em;
                        color: rgba(255, 255, 255, 0.3);
                    }
                    
                    p {
                        margin: 0;
                        font-size: 0.9rem;
                    }
                }
            }
            
            .actions-list {
                display: flex;
                flex-direction: column;
                gap: 1em;
                
                .action-btn {
                    display: flex;
                    align-items: center;
                    gap: 1em;
                    padding: 1em 1.5em;
                    background: rgba(255, 255, 255, 0.05);
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    border-radius: 8px;
                    color: rgba(255, 255, 255, 0.9);
                    font-size: 0.95rem;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.2s;
                    
                    svg {
                        font-size: 1.2rem;
                        color: ${({ theme }) => theme.primary};
                    }
                    
                    &:hover {
                        background: rgba(255, 255, 255, 0.1);
                        transform: translateX(5px);
                    }
                }
            }
            
            .system-overview {
                display: flex;
                flex-direction: column;
                gap: 1.5em;
                
                .overview-item {
                    display: flex;
                    gap: 1.2em;
                    align-items: center;
                    padding: 1em;
                    background: rgba(255, 255, 255, 0.03);
                    border-radius: 8px;
                    transition: all 0.2s;
                    
                    &:hover {
                        background: rgba(255, 255, 255, 0.06);
                    }
                    
                    .overview-icon {
                        width: 50px;
                        height: 50px;
                        border-radius: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 1.3rem;
                        flex-shrink: 0;
                    }
                    
                    .overview-content {
                        flex: 1;
                        
                        .overview-label {
                            font-size: 0.85rem;
                            color: rgba(255, 255, 255, 0.6);
                            margin: 0 0 0.3em 0;
                        }
                        
                        .overview-value {
                            font-size: 1.5rem;
                            font-weight: 700;
                            color: #fff;
                            margin: 0;
                        }
                    }
                }
            }
        }
    }
`
